import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const GetPersonalSpaceKeyQuery: GraphQLTaggedNode = graphql`
	query GetPersonalSpaceKeyQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;
